import CartNavigation from "../navigation/CartNavigation";
import CartProduct from "./CartProduct.js";
import CartNoProducts from "./CartNoProducts.js";
import CustomerDetailsModal from "../customer-details-modal/CustomerDetailsModal.js";
import ErrorAlert from "../../../common/ui/ErrorAlert.js";
import ErrorModal from "../../../common/ui/ErrorModal.js";
import OfflineModal from "../../../common/ui/OfflineModal.js";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";
import * as CommonUtilities from "../../../common/utils/CommonUtils.js";
import moment from "moment";
import {ReactComponent as S8PoweredByLogo} from "../../../images/S8PoweredLogo_Black.svg"; 
import Messages from "../../../common/ui/Messages.js";
// Date and Time Picker
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getYear, getMonth, addDays, subDays, setHours, setMinutes, getDay, getHours } from "date-fns";

export default function CartPage(props) {
    const pickupTimeOptions = [...Array(13)].map((item, index) => <option key={index * 5} value={index * 5}>{index === 0 ? 'ASAP' : index * 5 + ' mins' }</option>);
    const isWebOrder = props.urlConfig.Type === '' || props.urlConfig.Type === null || props.urlConfig.Type === 'null' || props.urlConfig.Type === 'web' ? true : false;

    // === Check Loading / Render Product & Total Price ===
    let totalPrice, products, subTotal, webProcessingFee, deliveryAndServiceFee, subTotalBottomPadding, voucher, productsInVoucher;
    let originalProductPriceVoucher = 0;
    let discountedProductPriceVoucher = 0;
    if (props.cartDetails.cartIsLoading) {
        // Loading
        products = 
            <div className="col-12 row p-0 m-0">
                <div className="col-sm-8 col-6 d-flex align-items-start gap-2 gap-sm-3">
                    <div className="col-sm-1 col-2 rounded-pill placeholder placeholder-wave bg-secondary" style={{height: "30px"}}></div>
                    <div className="d-flex flex-column justify-content-start col-sm-8 col-10 row ps-2">
                        <div className="placeholder placeholder-wave bg-secondary col-sm-4 col-8" style={{height: "20px"}}></div>
                        <div className="placeholder placeholder-wave bg-secondary col-sm-3 col-4 mt-2" style={{height: "10px"}}></div>
                    </div>
                </div>
                <div className="col-sm-4 col-6 text-end">
                    <div className="d-flex flex-column align-items-end">
                        <div className="placeholder placeholder-wave bg-secondary col-sm-4 col-6" style={{height: "20px"}}></div>
                        <div className="placeholder placeholder-wave bg-secondary col-sm-3 col-4 mt-2" style={{height: "10px"}}></div>
                    </div>
                </div>
                <div className="col-12 pt-1">
                    <hr className="text-body-tertiary" />
                </div>
            </div>
        totalPrice = <Spinner animation="border" role="status" variant="secondary" size="sm" className="ms-2 mb-n3" style={{height: "25px", width: "25px"}}></Spinner>;
        subTotal = <></>;
        webProcessingFee = <></>;
        deliveryAndServiceFee = <></>;
        subTotalBottomPadding = <></>;
    } else if (!props.cartDetails.cartIsLoading) {

        // Products
        if (props?.cartDetails?.cartDetails?.products?.length > 0 || props?.cartDetails?.cartDetails?.saleDiscountDetails != undefined && props?.cartDetails?.cartDetails?.saleDiscountDetails != null) {
            products = props.cartDetails.cartDetails.products.map((item) => {
                return (
                    <CartProduct 
                        key={item.recID}
                        data={item}
                        cartError={props.cartError}
                        handleQuantityChange={props.handleQuantityChange}
                        handleRemoveProdFromCart={props.handleRemoveProdFromCart}
                    />
                )
            })
        } else {
            products = <CartNoProducts orderPayBody={props.orderPayBody} />
        }

        // Voucher
        if (props?.cartDetails?.cartDetails?.saleDiscountDetails !== '' && props?.cartDetails?.cartDetails?.saleDiscountDetails !== null && props?.cartDetails?.cartDetails?.saleDiscountDetails !== undefined ) {
            let voucherDetails = props.cartDetails.cartDetails.saleDiscountDetails;
            productsInVoucher = voucherDetails?.cartUserTempAddedDiscountsProducts?.map((product) => {
                originalProductPriceVoucher += product.originalPrice;
                discountedProductPriceVoucher += product.priceInc;
                // Modifiers in each product in Voucher
                let modsInProduct;
                if (product?.cartUserTempAddedDiscountsModsList?.length > 0) {
                    let mods = product.cartUserTempAddedDiscountsModsList.map((mod) => {
                        discountedProductPriceVoucher += mod.priceInc;
                        let modPrice = CommonUtilities.formatDisplayPrice(mod.priceInc);
                        return <li key={mod.cartUserTempAddedDiscountsModsID}>{mod.productName}<span className="ms-2 ps-1">{modPrice}</span></li>
                    })
                    modsInProduct = 
                        <small className="text-muted">
                            <ul>
                                {mods}
                            </ul>
                        </small>
                } else {
                    modsInProduct = <></>
                }
                // Products in Voucher
                return (<div className="col-12 text-secondary" key={voucherDetails.cartUserTempAddedDiscountsProductsID}>
                            {product.productName}{modsInProduct}
                        </div>)
            })
            voucher =   <div className="col-12 row p-0 m-0" key={voucherDetails.cartUserTempAddedDiscountsID}>
                            <div className="col-8 d-flex align-items-start gap-2 gap-sm-3">
                                <div style={{width: "65px", height: "31px"}} className="rounded-pill bg-light border ps-2 d-flex align-items-center">
                                    <span key="1" style={{fontSize: "0.9rem"}}>1</span>
                                </div>
                                <div className="d-flex flex-column justify-content-start text-break">
                                    <b>{voucherDetails.loyaltyProductNameExternal}</b>
                                    {productsInVoucher}
                                </div>
                            </div>
                            <div className="col-4 text-end">
                                <div className="d-flex flex-sm-row flex-column justify-content-sm-end justify-content-start align-items-sm-start align-items-end">
                                    <span className="text-muted order-2 order-sm-1"><s>{CommonUtilities.StaticFields.CurrencySymbol}{(originalProductPriceVoucher).toFixed(2)}</s></span>
                                    <span className="ps-3 fw-bold order-1 order-sm-2">{CommonUtilities.StaticFields.CurrencySymbol}{(discountedProductPriceVoucher).toFixed(2)}</span>
                                </div>
                                <div>
                                    <a className="link-primary link-underline link-underline-opacity-0 link-offset-2 link-underline-opacity-50-hover" href="#" onClick={props.handleRemoveVoucherFromCart} data-addeddiscountid={voucherDetails.cartUserTempAddedDiscountsID}>Remove</a>
                                </div>
                            </div>
                            <div className="col-12">
                                <hr className="text-body-tertiary" />
                            </div>
                        </div>
        } else {
            voucher = <></>
        }

        // Total Price
        if (props?.cartDetails?.cartDetails?.totalInc) {
            totalPrice = `${CommonUtilities.StaticFields.CurrencySymbol}${(props.cartDetails.cartDetails.totalInc).toFixed(2)}`;
        } else {
            totalPrice = `${CommonUtilities.StaticFields.CurrencySymbol}${(0).toFixed(2)}`;
        }

        // Calculate Subtotal via Fees
        let serviceFeeWebOrderingValue, storeServiceFeeValue;

        // Service Fee - Web Ordering 
        if (props?.cartDetails?.cartDetails?.serviceFeeWebOrdering !== 0 && props?.cartDetails?.cartDetails?.serviceFeeWebOrdering !== '' && props?.cartDetails?.cartDetails?.serviceFeeWebOrdering !== null && props?.cartDetails?.cartDetails?.serviceFeeWebOrdering !== undefined) {
            serviceFeeWebOrderingValue = props.cartDetails.cartDetails.serviceFeeWebOrdering;
        } else {
            serviceFeeWebOrderingValue = 0;
        }
        
        // Delivery + Store Fee - Web Ordering 
        if (props?.cartDetails?.cartDetails?.storeServiceFee !== 0 && props?.cartDetails?.cartDetails?.storeServiceFee !== '' && props?.cartDetails?.cartDetails?.storeServiceFee !== null && props?.cartDetails?.cartDetails?.storeServiceFee !== undefined) {
            storeServiceFeeValue = props.cartDetails.cartDetails.storeServiceFee;
        } else {
            storeServiceFeeValue = 0;
        }
        
        
        // Service Fee - Web Ordering 
        if (serviceFeeWebOrderingValue !== 0 || storeServiceFeeValue !== 0) {
            subTotal = 
                <div className="col-12 text-center d-flex justify-content-center">
                    <div className="col-8 col-sm-5 col-md-3 d-flex flex-row justify-content-between text-muted">
                        <small>Subtotal</small>
                        <small>{`${CommonUtilities.StaticFields.CurrencySymbol}${(props.cartDetails.cartDetails.subTotal).toFixed(2)}`}</small>
                    </div>
                </div>
            subTotalBottomPadding = <div className="mb-3"></div>
                // Service Fee - Web Ordering
                if (serviceFeeWebOrderingValue !== 0) {
                    webProcessingFee = 
                        <div className="col-12 text-center d-flex justify-content-center">
                            <div className="col-8 col-sm-5 col-md-3 d-flex flex-row justify-content-between text-muted text-start">
                                <small>{props.cartDetails.cartDetails.serviceFeeWebOrderingMediaName}</small>
                                <small>{`${CommonUtilities.StaticFields.CurrencySymbol}${(props.cartDetails.cartDetails.serviceFeeWebOrdering).toFixed(2)}`}</small>
                            </div>
                        </div>
                } else {
                    webProcessingFee = <></>;
                }

                // Delivery + Store Fee - Web Ordering
                if (storeServiceFeeValue !== 0) {
                    deliveryAndServiceFee =
                        <div className="col-12 text-center d-flex justify-content-center">
                            <div className="col-8 col-sm-5 col-md-3 d-flex flex-row justify-content-between text-muted text-start">
                                <small>Delivery + Service Fee</small>
                                <small>{`${CommonUtilities.StaticFields.CurrencySymbol}${(props.cartDetails.cartDetails.storeServiceFee).toFixed(2)}`}</small>
                            </div>
                        </div>
                } else {
                    deliveryAndServiceFee = <></>;
                }
        } else {
            subTotal = <></>;
            subTotalBottomPadding = <></>;
        }
    }

    // === Store Hours ===
    // Today's Day
    const d = new Date();
    let dayIndex = d.getDay();
    //let dayIndex = 1; // Test different days

    let storeHoursWeekOriginalData = 
    [
        {
            DayIndex: 0,
            DayName: "Sunday",
            OpenTime: props.currentLocation.SundayOpenTime ? moment(props.currentLocation.SundayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.SundayCloseTime ? moment(props.currentLocation.SundayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 1,
            DayName: "Monday",
            OpenTime: props.currentLocation.MondayOpenTime ? moment(props.currentLocation.MondayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.MondayCloseTime ? moment(props.currentLocation.MondayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 2,
            DayName: "Tuesday",
            OpenTime: props.currentLocation.TuesdayOpenTime ? moment(props.currentLocation.TuesdayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.TuesdayCloseTime ? moment(props.currentLocation.TuesdayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 3,
            DayName: "Wednesday",
            OpenTime: props.currentLocation.WednesdayOpenTime ? moment(props.currentLocation.WednesdayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.WednesdayCloseTime ? moment(props.currentLocation.WednesdayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 4,
            DayName: "Thursday",
            OpenTime: props.currentLocation.ThursdayOpenTime ? moment(props.currentLocation.ThursdayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.ThursdayCloseTime ? moment(props.currentLocation.ThursdayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 5,
            DayName: "Friday",
            OpenTime: props.currentLocation.FridayOpenTime ? moment(props.currentLocation.FridayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.FridayCloseTime ? moment(props.currentLocation.FridayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 6,
            DayName: "Saturday",
            OpenTime: props.currentLocation.SaturdayOpenTime ? moment(props.currentLocation.SaturdayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.SaturdayCloseTime ? moment(props.currentLocation.SaturdayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        }
    ]

    let todayHours = storeHoursWeekOriginalData[dayIndex];
    let firstHalfWeek = [];
    let secondHalfWeek = [];
    let todayDisplayHours = todayHours.OpenTime || todayHours.CloseTime ? `${todayHours.OpenTime} - ${todayHours.CloseTime}` : "Closed";

    if (dayIndex < 6) {
        firstHalfWeek = storeHoursWeekOriginalData.slice(dayIndex + 1);
    } 
    if (dayIndex > 0) {
        secondHalfWeek = storeHoursWeekOriginalData.slice(0, dayIndex);
    }
    let weekHoursDataToShow = [...firstHalfWeek, ...secondHalfWeek];
    let weekDisplayHours = weekHoursDataToShow.map((item) => {
        let itemDisplayHours = item.OpenTime || item.CloseTime ? `${item.OpenTime} - ${item.CloseTime}` : "Closed";
        return (
            <tr key={item.DayIndex}>
                <td className="ps-sm-5 pe-sm-4 px-2">{item.DayName}</td>
                <td>{itemDisplayHours}</td>
            </tr>
        )
    });

    let calError = props.currentLocation.Validation.CalendarHasError ? "form-control is-invalid" : "form-control";
    let calInvalidFeedbackClass = props.currentLocation.Validation.CalendarHasError ? "invalid-feedback d-block" : "invalid-feedback";
    // === Show Pickup Time / Calendar ===
    
    // ---------- Function - Cart: Filter Days ----------
    const isOpenDay = (date) => {
        const day = getDay(date);
        let sunCheck, monCheck, tuesCheck, wedCheck, thurCheck, friCheck, satCheck;
        if (props.currentLocation.SundayOpenTime !== null && props.currentLocation.SundayCloseTime !== null && props.currentLocation.SundayOpenTime !== "Invalid date" && props.currentLocation.SundayCloseTime !== "Invalid date") {
            sunCheck = day === 0;
        } 
        if (props.currentLocation.MondayOpenTime !== null && props.currentLocation.MondayCloseTime !== null && props.currentLocation.MondayOpenTime !== "Invalid date" && props.currentLocation.MondayCloseTime !== "Invalid date") {
            monCheck = day == 1;
        }
        if (props.currentLocation.TuesdayOpenTime !== null && props.currentLocation.TuesdayCloseTime !== null && props.currentLocation.TuesdayOpenTime !== "Invalid date" && props.currentLocation.TuesdayCloseTime !== "Invalid date") {
            tuesCheck = day == 2;
        }
        if (props.currentLocation.WednesdayOpenTime !== null && props.currentLocation.WednesdayCloseTime !== null && props.currentLocation.WednesdayOpenTime !== "Invalid date" && props.currentLocation.WednesdayCloseTime !== "Invalid date") {
            wedCheck = day == 3;
        }
        if (props.currentLocation.ThursdayOpenTime !== null && props.currentLocation.ThursdayCloseTime !== null && props.currentLocation.ThursdayOpenTime !== "Invalid date" && props.currentLocation.ThursdayCloseTime !== "Invalid date") {
            thurCheck = day == 4;
        }
        if (props.currentLocation.FridayOpenTime !== null && props.currentLocation.FridayCloseTime !== null && props.currentLocation.FridayOpenTime !== "Invalid date" && props.currentLocation.FridayCloseTime !== "Invalid date") {
            friCheck = day == 5;
        }
        if (props.currentLocation.SaturdayOpenTime !== null && props.currentLocation.SaturdayCloseTime !== null && props.currentLocation.SaturdayOpenTime !== "Invalid date" && props.currentLocation.SaturdayCloseTime !== "Invalid date") {
            satCheck = day == 6;
        }
        return sunCheck || monCheck || tuesCheck || wedCheck || thurCheck || friCheck || satCheck;
    };

    // ---------- Function - Cart: Filter Times ----------
    const filteredTimes = (time) => {
        let offsetStartTime = CommonUtilities.StaticFields.OffsetStartTimeByMinutes == '' || CommonUtilities.StaticFields.OffsetStartTimeByMinutes == null ? 0 : CommonUtilities.StaticFields.OffsetStartTimeByMinutes;
        let selectedDay = props.currentLocation.CalendarValue;
        if (selectedDay == '' || selectedDay == null) {
            return
        }
        const dayOfWeek = selectedDay.getDay();
        if (dayOfWeek === 0) { // Sunday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.SundayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.SundayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.SundayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.SundayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 1) { // Monday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.MondayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.MondayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.MondayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.MondayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 2) { // Tuesday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.TuesdayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.TuesdayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.TuesdayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.TuesdayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 3) { // Wednesday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.WednesdayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.WednesdayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.WednesdayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.WednesdayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 4) { // Thursday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.ThursdayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.ThursdayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.ThursdayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.ThursdayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 5) { // Friday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.FridayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.FridayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.FridayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.FridayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 6) { // Saturday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.SaturdayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.SaturdayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.SaturdayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.SaturdayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        }
    }

    let pickupTimeOrCalendar = CommonUtilities.StaticFields.ShowCalendar ? 
        // Calendar
        <div className="pt-sm-2 pt-3">
            <DatePicker
                onChange={props.handleCalendarChange}
                selected={props.currentLocation.CalendarValue} 
                value={props.currentLocation.CalendarValue}
                showTimeSelect
                showIcon
                minDate={addDays(new Date(), props.currentLocation.CalendarConfig.CalendarMinDays)}
                maxDate={addDays(new Date(), props.currentLocation.CalendarConfig.CalendarMaxDays)}
                filterDate={isOpenDay}
                filterTime={filteredTimes}
                className={calError}
                wrapperClassName="w-100"
                dateFormat="dd/MM/yyyy h:mm aa"
            />
            <div className={calInvalidFeedbackClass}>{props.currentLocation.Validation.CalendarErrorMessage}</div>
        </div>
        :
        // Pickup time
        <InputGroup className="col-6 mt-3">
            <InputGroup.Text className="rounded-start-pill px-sm-4">
                Pick up
            </InputGroup.Text>
            <Form.Select className="text-center rounded-end-pill" value={props.currentLocation.PickupTimeValue} onChange={props.handlePickupTimeChange} disabled={props.cartError.ButtonsDisabled}>
                {pickupTimeOptions}
            </Form.Select>
        </InputGroup> 

    return (
        <>
            <CartNavigation
                cartError={props.cartError}
                handleBackClickCart={props.handleBackClickCart}
            />
            <div className="container-lg">
                {isWebOrder && props.pickupOrDelivery.SwitchMenuNav.SwitchPickupDeliveryValue === 'pickup' &&
                    <div className="border border-light-subtle border-2 rounded-3 mt-4 p-3 p-sm-4">
                        <div className="row">
                            <div className="h5 col-12 mb-3 text-center">Pickup Location</div>
                            <div className="col-sm-8 col-md-7 col-lg-6 col-xl-4">
                                {props.currentLocation.LocationName && <><b>{props.currentLocation.LocationName}</b><br /></>}
                                {props.currentLocation.LocationAddressLine1 && <><span>{props.currentLocation.LocationAddressLine1}</span><br /></>}
                                {props.currentLocation.LocationAddressLine2 && <><span>{props.currentLocation.LocationAddressLine2}</span><br /></>}
                                <span>{props?.currentLocation?.LocationSuburb} {props?.currentLocation?.LocationState} {props?.currentLocation?.LocationPostcode}</span><br />

                                {/* === Store Hours - TO DO > Uncomment when backend ready === */}
                                {/* <div id="accordionStoreHours" className="accordion my-2">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                        <button type="button" className="accordion-button collapsed p-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseStoreHours" aria-expanded="false" aria-controls="collapseStoreHours">
                                            <small className="fw-medium">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className="pe-sm-1">Hours</td>
                                                            <td className="ps-sm-3 pe-sm-5 px-2">{todayHours.DayName}</td>
                                                            <td>{todayDisplayHours}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </small>
                                        </button>
                                        </h2>
                                        <div id="collapseStoreHours" className="accordion-collapse collapse" data-bs-parent="#accordionStoreHours">
                                            <div className="accordion-body">
                                                <small>
                                                    <table>
                                                        <tbody>
                                                            {weekDisplayHours}
                                                        </tbody>
                                                    </table>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-sm-4 col-md-5 col-lg-6 col-xl-8 text-sm-end text-start">{props.currentLocation.LocationDistance !== "" && `${props.currentLocation.LocationDistance}kms`}</div>
                            { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && 
                            <div className="col-12 row p-0 m-0 justify-content-center">
                                <div className="col-sm-8 col-md-6 d-grid gap-2">
                                        {pickupTimeOrCalendar}
                                </div>                           
                            </div> }
                        </div>
                    </div>
                }
                <div className="border border-light-subtle border-2 rounded-3 mt-4 p-3 p-sm-4">
                    <div className="row">
                        <div className="h5 col-12 mb-3 text-center">Your Order</div>
                        {products}
                        {voucher}
                        { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && 
                        <div className="col-12 row p-0 m-0">
                            <div className={CommonUtilities.StaticFields.HideKitchenNotes ? "form-floating d-none" : "form-floating"}>
                                <textarea className={props.orderPayBody.validation.RestaurantInstructions.HasError ? "form-control is-invalid" : "form-control"} name="txtareaOrderNotes" placeholder="Kitchen Instructions" style={{height: "100px"}} value={props.orderPayBody.data.OrderNote} onChange={props.handleCartNotes} maxLength="300"></textarea>
                                <label style={{marginLeft: "12px"}}>Kitchen instructions</label>
                                <small className="invalid-feedback">{props.orderPayBody.validation.RestaurantInstructions.ErrorMessage}</small>
                            </div>
                        </div> }
                    </div>
                </div>
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber && 
                <div className="position-sticky bottom-0 bg-white z-2 rounded-3">
                    <div className="border border-light-subtle border-2 rounded-3 my-4 p-3 p-sm-4">
                        <div className="row justify-content-center">
                            {subTotal}
                            {deliveryAndServiceFee}
                            {webProcessingFee}
                            {subTotalBottomPadding}
                            <div className="col-12 text-center h5">
                                Total {totalPrice}
                            </div>
                            <small className="col-12 text-center text-muted mt-1">
                                All prices are in AUD and include GST<br />
                                Order enquires and refunds will be handled by the merchant
                            </small>
                            <div className="col-12 row p-0 m-0 justify-content-center">
                                <div className="col-sm-8 col-md-6 d-grid gap-2">
                                    <button type="button" className="btn btn-dark rounded-pill mt-3" onClick={props.handleValidateCart}>
                                        Order & Pay
                                    </button>
                                </div>
                            </div>
                        </div>
                        {props.cartError.HasError && <div className="mt-4"><ErrorAlert message={props.cartError.Message} /></div>}
                    </div>
                    <div className="d-flex flex-row justify-content-center pt-4 pb-4">
                        <a href="https://www.shift8.com/" target="_blank" rel="noreferrer">
                            <svg role="img" width="80px" height="28px" alt="Powered by Shift8" aria-labelledby="Powered by Shift8">
                                <title>Powered by Shift8</title>
                                <S8PoweredByLogo />
                            </svg>
                        </a>
                    </div>
                </div>}
            </div>
            <CustomerDetailsModal
                showCustomerDetailsModal={props.showCustomerDetailsModal} 
                customerDetailsFormData={props.customerDetailsFormData}
                handleCloseCustomerDetailsModal={props.handleCloseCustomerDetailsModal}
                handleChangeCustDetails={props.handleChangeCustDetails}
                handleSubmitCustDetails={props.handleSubmitCustDetails}
                urlConfig={props.urlConfig}
                // --- Pickup / Delivery ---
                pickupOrDelivery={props.pickupOrDelivery}
                // --- Loyalty ---
                loyaltyIsLoggedIn={props.loyaltyIsLoggedIn} // Part of loyaltyMember State
            />
            <ErrorModal 
                errorModal={props.errorModal}
                handleCloseErrorModal={props.handleCloseErrorModal}
            />
            <OfflineModal
                offlineModal={props.offlineModal}
                handleCloseOfflineModal={props.handleCloseOfflineModal}
                urlConfig={props.urlConfig}
            />
        </>
    )
}